import React, { createContext, useContext } from "react";

export const METRIKA_ID = 93997310;

/**
 * Откуда покупка: store — «другие магазины» (/store/...), deals — страницы скидок и каталог,
 * favorites — избранное в кабинете, steam — пополнение Steam на /steam.
 */
export const PURCHASE_SOURCES = ["store", "deals", "favorites", "steam"];

export function reachGoal(goal, params) {
  try {
    window.ym?.(METRIKA_ID, "reachGoal", goal, params);
  } catch {
    // Метрика заблокирована или не загрузилась — покупке это не мешает.
  }
}

const PurchaseSourceContext = createContext(null);

export function usePurchaseSource(fallback) {
  return useContext(PurchaseSourceContext) || fallback;
}

/** Источник для вложенных форм покупки; внешний источник (например, избранное) важнее. */
export function PurchaseSource({ value, children }) {
  const outer = useContext(PurchaseSourceContext);
  return (
    <PurchaseSourceContext.Provider value={outer || value}>{children}</PurchaseSourceContext.Provider>
  );
}

/** Задаёт источник для всего, что внутри, перекрывая внутренние значения по умолчанию. */
export function PurchaseSourceOverride({ value, children }) {
  return <PurchaseSourceContext.Provider value={value}>{children}</PurchaseSourceContext.Provider>;
}

/** Счёт создан: цель источника и общая цель. Сумма, номер заказа и итог оплаты в Метрику не уходят. */
export function trackInvoice(source, { multi } = {}) {
  const params = { source, ...(multi ? { multi: true } : {}) };
  reachGoal("invoice", params);
  reachGoal(`invoice_${source}`, params);
}
